import { ChangeDetectorRef, Component, effect, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule, CurrencyPipe, NgIf } from '@angular/common';
import { UntypedFormGroup } from '@angular/forms';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { PaymentResponseData } from '@sbd-account-portal/app/modules/payment/payment.types';
import { User } from '@sbd-account-portal/app/core/user/user.types';
import {
  OpenQuoteRequestsItem
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/quote-requests.types';
import { toObservable } from '@angular/core/rxjs-interop';
import { map, Subject, takeUntil } from 'rxjs';
import { MainFuseDrawerService } from '@sbd-account-portal/app/modules/main-fuse-drawer/main-fuse-drawer.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'sbd-account-portal-frontend-purchase-confirmation-page-view',
  standalone: true,
  imports: [
    CommonModule,
    NgIf,
    CurrencyPipe,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardTitle,
    MatDivider,
    MatIcon,
    MatIconButton,
    MatProgressSpinner,
  ],
  templateUrl: './purchase-confirmation-page-view.component.html'
})
export class PurchaseConfirmationPageViewComponent {
  @Input() selectedQR: OpenQuoteRequestsItem | null = null;
  @Input() queuedQR: OpenQuoteRequestsItem[] = [];
  @Input() subtotal: number = 0;
  @Input() checkoutForm: UntypedFormGroup;
  @Input() loggedInAccountUser: User;
  @Input() isPurchased: boolean = false;
  @Input() recentlyPurchasedCount: number = 0;

  @Output() moveBackEvent = new EventEmitter<void>();
  @Output() closeDrawerEvent = new EventEmitter<void>();
  @Input() showCloseButton!: boolean;
  _mainFuseDrawerService = inject(MainFuseDrawerService)
  _unsubscribeAll: Subject<void> = new Subject<void>();
  _changeDetector = inject(ChangeDetectorRef);
  paymentResponseData: PaymentResponseData ;
  isPurchasing: boolean = false;

  isPurchasing$ = toObservable(this._mainFuseDrawerService.isPurchasing).pipe(
    takeUntil(this._unsubscribeAll),
    map((isPurchasing) => {
      this.isPurchasing = isPurchasing;
      this._changeDetector.detectChanges();
    }),
  ).subscribe();

  paymentResponseData$ = toObservable(this._mainFuseDrawerService.paymentResponseData).pipe(
    takeUntil(this._unsubscribeAll),
    map((paymentResponseData) => {
      this.paymentResponseData = paymentResponseData;
      this._changeDetector.detectChanges();
    }),
  ).subscribe();

  moveBack() {
    this.moveBackEvent.emit();
  }

  closeDrawer() {
    this.closeDrawerEvent.emit();
  }
}
